import { render, staticRenderFns } from "./DeleteCouponPopup.vue?vue&type=template&id=23522645&scoped=true&"
import script from "./DeleteCouponPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteCouponPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteCouponPopup.vue?vue&type=style&index=0&id=23522645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23522645",
  null
  
)

export default component.exports